(function (upp) {
    'use strict';

    PasswordChangeComponent.$inject = [ '$scope' ];
    function PasswordChangeComponent($scope) {
        Object.defineProperties(this, {
            password: { value: '', writable: true },
            passwordConfirm: { value: '', writable: true },
            onChange: { get: function() { return $scope.onChange || angular.noop }, enumerable: true },
        });
    }

    PasswordChangeComponent.prototype.notifyChanges = function() {
    	var password = this.password === this.passwordConfirm ? this.password : null;
        this.onChange({ $event: password });
    }

    upp.directive('passwordChange', [ function () {
        return {
            restrict: 'E',
            scope: {
                onChange: '&?',
            },
            templateUrl: require('../templates/password-change.html'),
            controllerAs: '$ctrl',
            controller: PasswordChangeComponent,
        };
    } ]);

}(upp));


// WEBPACK FOOTER //
// ./src/app/modules/customer-account/component/password-change.component.js